import { Address } from 'src/shared/types/user';

import { cn } from 'src/shared/components/ui';

import { Typography } from '../ui';

interface AddressBlockProps {
  address: Address;
  nameWeight?: 'bold' | 'medium' | 'regular';
  contentWeight?: 'bold' | 'medium' | 'regular';
  contentClassName?: string;
}

const AddressBlock: React.FC<AddressBlockProps> = ({
  address,
  nameWeight = 'regular',
  contentWeight = 'regular',
  contentClassName = 'text-secondary-text'
}) => {
  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-2">
        <Typography variant="body-1" weight={nameWeight}>
          {address?.name}
        </Typography>
        {/* <div className="px-[6px] py-[2px] bg-gray-2 rounded-md">
          <Typography variant="body-3" weight="medium">
            Default
          </Typography>
        </div> */}
      </div>
      <Typography
        variant="body-1"
        className={cn('text-secondary-text', contentClassName)}
        weight={contentWeight}
      >
        {address.line_1}, {address.line_2}, {address.state}, {address.city}{' '}
        {address.zip_code} {address.country}
      </Typography>
      <Typography
        variant="body-1"
        className={cn('text-secondary-text', contentClassName)}
        weight={contentWeight}
      >
        {address?.contact_name}
      </Typography>
      <Typography
        variant="body-1"
        className={cn('text-secondary-text', contentClassName)}
        weight={contentWeight}
      >
        {address?.contact_phone}
      </Typography>
      {address?.contact_email && (
        <Typography
          variant="body-1"
          className={cn('text-secondary-text', contentClassName)}
          weight={contentWeight}
        >
          {address.contact_email}
        </Typography>
      )}
    </div>
  );
};

export default AddressBlock;
